import {Component, OnInit} from '@angular/core';
import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {LoanApplication} from 'src/app/@models/loan-application.model';
import {LoanApplicationService} from '../../loan-application.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'bb-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
})
export class RequestComponent implements OnInit {
  target_loan_amount = this.loan.form.get('target_loan_amount');
  min = this.loan.form.get('slider_config').value.target_loan_duration.min;
  max = this.loan.form.get('slider_config').value.target_loan_duration.max - this.min + 1;
  durations = Observable.range(this.min, this.max).toArray();
  employment_type = this.loan.form.get('employment_info.employment_type');

  constructor(public loan: LoanApplicationService) {
  }

  ngOnInit(): void {
    const bounds = LoanApplication.LoanAmountBounds[this.employment_type.value];
    this.target_loan_amount.setValidators([
      Validators.required,
      this.rangeValidator(bounds.min, bounds.max),
      this.incrementValidator(bounds.step)
    ]);
  }

  rangeValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;
      if (value !== null && (isNaN(value) || value < min || value > max)) {
        return { 'range': true };
      }
      return null;
    };
  }

  incrementValidator(step: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;
      if (value !== null && value % step !== 0) {
        return { 'increment': true };
      }
      return null;
    };
  }
}
